import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { acknowledgeHostedAgentAlert, listHostedAgentAlerts } from "@/api/admin-api"

import { FAST_STALE_TIME, GC_TIME } from "./_shared"

// Operational alerts (#3039): raised server-side by the budget quota and the
// health sweep; the dashboard lists the open ones and lets an admin
// acknowledge them. Acknowledging closes the alert, so every ack invalidates
// the listing.
const HOSTED_AGENTS_KEY = ["admin", "hosted-agents"] as const
const ALERTS_KEY = [...HOSTED_AGENTS_KEY, "alerts"] as const

/** Refresh cadence for the open-alerts card while it is mounted. */
export const HOSTED_AGENT_ALERTS_POLL_MS = 60_000

/** Open alerts tenant-wide, newest first. */
export function useAdminHostedAgentAlertsQuery(enabled = true) {
  return useQuery({
    queryKey: [...ALERTS_KEY, "open"],
    queryFn: () => listHostedAgentAlerts({ status: "open" }),
    enabled,
    staleTime: FAST_STALE_TIME,
    gcTime: GC_TIME,
    refetchInterval: HOSTED_AGENT_ALERTS_POLL_MS,
  })
}

export function useAcknowledgeHostedAgentAlertMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (alertId: string) => acknowledgeHostedAgentAlert(alertId),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ALERTS_KEY }),
  })
}
